import React from 'react'
import styled from 'styled-components'
import tw from 'tailwind.macro'
import { Parallax } from 'react-spring/renderprops-addons.cjs'

// Components
import Layout from '../components/Layout'

// Elements
import { AltTitle, BigTitle } from '../elements/Titles'
import { HeroImage, RoleWrapper, RoleHeader, RoleItem, SectionCopy, AltSectionCopy} from '../elements/Section'

// Views
import Hero from '../views/Hero'
import Section from '../views/Section'
import AltSection from '../views/AltSection'

import HeroImg from '../images/itDepends.jpg'

const ItDepends = () => (
  <>
    <Layout />
    <Parallax pages={6}>
      <Hero offset={0}>
        <BigTitle>
          It Depends
        </BigTitle>
        <RoleWrapper><RoleHeader>My Role:</RoleHeader><RoleItem>Full Stack Developer</RoleItem></RoleWrapper>
        <HeroImage src={HeroImg}/>
      </Hero>
      <Section offset={1}>
        <AltTitle>CHALLENGE</AltTitle>
        <SectionCopy>Human Centered Design revolves around building products or experiences that involve users all along its life cycle. During this long cycle, a lot of questions are answered with the phrase "It Depends", solely because the answer depends on a lot of parameters.<br/><br/>In order to record the number of times I personally or otherwise heard others use this phrase, I intended to build a phrase tracker.</SectionCopy>
      </Section>
      <AltSection offset={3}>
        <AltTitle>PROCESS</AltTitle>
        <AltSectionCopy><a href="https://serverless.com/">Serverless Framework</a>, <a href="https://aws.amazon.com/lambda/">AWS Lambda</a> & <a href="https://aws.amazon.com/api-gateway/">API Gateway</a> for developing and deploying serverless API<br/><br/><a href="https://aws.amazon.com/dynamodb/">DynamoDB</a> for the database<br/><br/><a href="https://aws.amazon.com/iam/details/manage-roles/">IAM Roles</a> to obtain temporary access to make API calls from frontend<br/><br/><a href="https://reactjs.org/">React.js</a> for the single page application<br/><br/><a href="https://aws-amplify.github.io/">AWS Amplify</a> for connecting to our backend<br/><br/><a href="https://aws.amazon.com/websites/">S3</a> for hosting the website</AltSectionCopy>
      </AltSection>
      <Section offset={4}>
        <AltTitle>EVALUATION</AltTitle>
        <SectionCopy><a href="http://itdepends-client.s3-website-us-west-2.amazonaws.com/">Link to Web Application</a><br/><br/><br/><a href="https://aws.amazon.com/">Amazon Web Services</a> provides a plethora of services that help with building a full stack application. Through this project, I was able to understand the workflow of a few such services and leverage that knowledge to build other complex applications.<br/><br/>I was also able to access the pros, cons and the need for building serverless applications and exploit its ability to develop infinitely scaleable, pay-per-execution APIs.</SectionCopy>
      </Section>
    </Parallax>
  </>
)

export default ItDepends
